import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import videoService from "../Services/videoService";
import Swal from "sweetalert2";

export default function VideoWatchingPlatform() {
  const [episode, setEpisode] = useState({});
  const { episodeId } = useParams();

  useEffect(() => {
    videoService.findEpisodeById(episodeId).then((res) => {
      if (res.success) {
        setEpisode(res.episode);
      } else {
        Swal.fire("וידאו לא קיים", "", "warning");
      }
    });
  }, []);

  return (
    <div className="pb-40">
      <div className="center">
        <img width="350px" alt="video" src="https://practicum-classes.s3.eu-central-1.amazonaws.com/logo-practicum.png" />

        <h1 className="mb-50">{episode.title}</h1>
      </div>

      <video src={episode.link} width="100%" height="600" onContextMenu={(e) => e.preventDefault()} controls controlsList="nodownload">
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
